export abstract class Processor {
  abstract start(): void;
  abstract isEnabled(): boolean;
}
